const shortDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

const longDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const dayFormatter = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric",
});

export const inviteStatusOrder = [
  "SENT",
  "OPENED",
  "ACCEPTED",
  "BOOKED",
] as const;

export type InviteStatus = (typeof inviteStatusOrder)[number];

export type InviteeLike = {
  status: InviteStatus;
};

export function formatShortDate(isoDate: string) {
  if (!isoDate) {
    return "Date TBD";
  }

  const dateOnly = isoDate.slice(0, 10);
  const parsedDate = new Date(`${dateOnly}T12:00:00`);

  if (Number.isNaN(parsedDate.getTime())) {
    return isoDate;
  }

  return shortDateFormatter.format(parsedDate);
}

export function formatLongDate(isoDate: string) {
  if (!isoDate) {
    return "Date TBD";
  }

  const dateOnly = isoDate.slice(0, 10);
  const parsedDate = new Date(`${dateOnly}T12:00:00`);

  if (Number.isNaN(parsedDate.getTime())) {
    return isoDate;
  }

  return longDateFormatter.format(parsedDate);
}

export function formatDayLabel(isoDate: string) {
  if (!isoDate) {
    return "Date TBD";
  }

  const dateOnly = isoDate.slice(0, 10);
  const parsedDate = new Date(`${dateOnly}T12:00:00`);

  if (Number.isNaN(parsedDate.getTime())) {
    return isoDate;
  }

  return dayFormatter.format(parsedDate);
}

export function buildEventLandingPageUrl(eventId: string) {
  if (!eventId) {
    return "";
  }

  const url = new URL(window.location.href);
  url.search = "";
  url.hash = `/events/${eventId}/landing-page`;
  return url.toString();
}

export function formatDateRange(startIsoDate: string, endIsoDate: string) {
  return `${formatShortDate(startIsoDate)} - ${formatShortDate(endIsoDate)}`;
}

export function escapeCsvValue(value: string) {
  const normalizedValue = /^[\t\r ]*[=+\-@]/.test(value) ? `'${value}` : value;

  return `"${normalizedValue.replaceAll('"', '""')}"`;
}

export function countInviteeStatuses<T extends InviteeLike>(invitees: T[]) {
  return inviteStatusOrder.map((status) => ({
    status,
    count: invitees.filter((invitee) => invitee.status === status).length,
  }));
}

export function createEventId(existingIds: string[]) {
  const numericIds = existingIds
    .map((value) => Number.parseInt(value.replace("EVT-", ""), 10))
    .filter((value) => Number.isFinite(value));

  const nextId = Math.max(8582, ...numericIds) + 1;
  return `EVT-${nextId}`;
}

export function createSlug(value: string) {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function initialsForName(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);

  return parts.map((part) => part[0]?.toUpperCase() ?? "").join("");
}
